import { ConfirmationDialog } from '@/components/custom/erp';
import { useVatTuSanPhamContext } from '../context';

export const DeleteDialog = () => {
  const { showDelete, handleCloseDelete, deleteItem, selectedObj, clearSelection, handleCloseForm } =
    useVatTuSanPhamContext();

  if (!showDelete) return null;

  return (
    <ConfirmationDialog
      open={showDelete}
      onClose={handleCloseDelete}
      onConfirm={() => {
        if (selectedObj?.uuid) {
          deleteItem(selectedObj.uuid);
        }
        handleCloseDelete();
        clearSelection();
        handleCloseForm();
      }}
    />
  );
};
